module.exports = __webpack_public_path__ + "img/agricultura_familiar_prata.f919a4f1.png";